import createSvgIcon from "./utils/createSvgIcon";

export default createSvgIcon(
  <>
    <path fillOpacity=".3" d="M2 22h20V2z"></path>
    <path d="M14 10L2 22h12z"></path>
  </>,
  "SignalCellular3Bar"
);
